import Spinner from '@components/_elements/Spinner/Spinner';
import SetupWizard from '@components/Wizard';
import protectedLoader from '@pages/_loader';
import AdminRoutes from '@pages/Admin/routes';
import BatteryRoutes from '@pages/Battery/routes';
import HistorianTableViewRoutes from '@pages/HistorianTableView/routes';
import HistoryRoutes from '@pages/History/routes';
import HomeRoutes from '@pages/Home/routes';
import IncidentCommandRoutes from '@pages/IncidentCommand/routes';
import MktRoutes from '@pages/Mkt/routes';
import PageError, { PageNotFound } from '@pages/PageError';
import SunRoutes from '@pages/Sun/routes';
import WindRoutes from '@pages/Wind/routes';
import { store } from '@store';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from '@utils/queryClient';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router';
import App from './App';

function PageErrorWithQueryClient() {
  return (
    <QueryClientProvider client={queryClient}>
      <PageError />
    </QueryClientProvider>
  );
}

function AppWithStore() {
  return (
    <ErrorBoundary fallback={<PageErrorWithQueryClient />}>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  );
}

const router = createBrowserRouter([
  {
    id: 'root',
    loader: protectedLoader,
    hydrateFallbackElement: <Spinner type='fullPage' />,
    element: <AppWithStore />,
    errorElement: <PageErrorWithQueryClient />,
    children: [
      ...AdminRoutes,
      ...HistorianTableViewRoutes,
      ...HomeRoutes,
      ...BatteryRoutes,
      ...SunRoutes,
      ...MktRoutes,
      ...HistoryRoutes,
      ...WindRoutes,
      ...IncidentCommandRoutes,
      {
        path: '/wizard',
        element: <SetupWizard />,
      },
      {
        path: '*',
        element: <PageNotFound />,
      },
    ],
  },
]);

function AppRouter() {
  return <RouterProvider router={router} />;
}

export default AppRouter;
